import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export default function Hours() {
  const [hours, setHours] = useState(null);
  useEffect(() => { api.get("/business").then(r => setHours(r.data.hours)); }, []);
  if (!hours) return <div className="p-8 text-slate-500">Loading…</div>;

  const update = (day, patch) => setHours({ ...hours, [day]: { ...hours[day], ...patch } });
  const save = async () => {
    try { await api.patch("/business", { hours, onboarding: { hours: true } }); toast.success("Hours saved"); }
    catch { toast.error("Save failed"); }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight">Business hours</h1>
      <p className="text-slate-600 mt-1">ASFA uses these to answer callers.</p>
      <div className="mt-8 bg-white border border-slate-200 rounded-2xl p-6 max-w-2xl">
        <div className="space-y-3">
          {days.map(d => (
            <div key={d} className="grid grid-cols-12 gap-3 items-center" data-testid={`hours-row-${d}`}>
              <div className="col-span-3 capitalize font-medium">{d}</div>
              <div className="col-span-2"><Switch data-testid={`hours-open-${d}`} checked={hours[d]?.open || false} onCheckedChange={(v) => update(d, { open: v })} /></div>
              <div className="col-span-3"><Input data-testid={`hours-start-${d}`} type="time" value={hours[d]?.start || "09:00"} disabled={!hours[d]?.open} onChange={(e) => update(d, { start: e.target.value })} /></div>
              <div className="col-span-1 text-center text-slate-400">–</div>
              <div className="col-span-3"><Input data-testid={`hours-end-${d}`} type="time" value={hours[d]?.end || "17:00"} disabled={!hours[d]?.open} onChange={(e) => update(d, { end: e.target.value })} /></div>
            </div>
          ))}
        </div>
        <Button data-testid="hours-save-btn" onClick={save} className="mt-6 rounded-xl bg-blue-600 hover:bg-blue-700">Save hours</Button>
      </div>
    </div>
  );
}
